import React from 'react';
import ChangeImage from './ChangeImage';
import ChangeText from './ChangeText';
import { ChromePicker } from 'react-color';

import I18n from '../../locales/i18n';

import Logo from '../../img/EventoVirtual_LogoHorizontal.png';
import LogoLigth from '../../img/EventoVirtual_Logo_NegativoColorCorp_Horizontal.png';
import Favicon from '../../img/favicon.png';

const View = ({
	setParam,
	onRequestLoading,
	bdData,
	folder = 'none',
	handleLogoValidation,
	handleFaviconValidation,
}) => {
	const {
			customLogo = false,
			customLogoBlack = false,
			customLogoLigth = false,
			customFavicon = false,
			customFooter = '',
			customLink = '',
			customPrimaryColor = '#6F42C1',
		} = bdData,
		_path = `https://static.eventovirtual.co/v1/AUTH_93e97be4d41e467687f422fd1a8ce372/eventovirtual-public/${folder}`;

	const [loadingPrimaryColor, setLoadingPrimaryColor] = React.useState(false),
		[primaryColor, setPrimaryColor] = React.useState(customPrimaryColor);

	return (
		<div className="content clearfix pd-30 pd-sm-40">
			<div className="alert alert-info" role="alert">
				<strong>Hey, {I18n('MY_BRAND', 'PICTURE_RESIZING_ALERT')}</strong>
			</div>
			<FormControl title={I18n('MY_BRAND', 'LOGO_IN_DARK_THEME')}>
				<ChangeImage
					className="event_img_row i300x68 bDark"
					onRequestLoading={onRequestLoading}
					image={customLogo ? `${_path}/LOGO` : Logo}
					defaultImage={Logo}
					name={'LOGO'}
					dbName={'customLogo'}
					setParam={setParam}
					onValidation={handleLogoValidation}
					folder={folder}
				/>
			</FormControl>

			<FormControl title={I18n('MY_BRAND', 'LOGO_IN_LIGHT_THEME')}>
				<ChangeImage
					className="event_img_row i300x68 bLigth"
					onRequestLoading={onRequestLoading}
					image={customLogoLigth ? `${_path}/LOGO_LIGTH` : Logo}
					defaultImage={Logo}
					name={'LOGO_LIGTH'}
					dbName={'customLogoLigth'}
					setParam={setParam}
					onValidation={handleLogoValidation}
					folder={folder}
				/>
			</FormControl>

			<FormControl title={I18n('MY_BRAND', 'LOGIN_LOGO')}>
				<ChangeImage
					className="event_img_row i300x68 bBlack"
					onRequestLoading={onRequestLoading}
					image={customLogoBlack ? `${_path}/LOGO_BLACK` : LogoLigth}
					defaultImage={LogoLigth}
					name={'LOGO_BLACK'}
					dbName={'customLogoBlack'}
					setParam={setParam}
					onValidation={handleLogoValidation}
					folder={folder}
				/>
			</FormControl>

			<FormControl title={I18n('MY_BRAND', 'FAVICON')}>
				<ChangeImage
					className="event_img_row iautox68"
					onRequestLoading={onRequestLoading}
					image={customFavicon ? `${_path}/FAVICON` : Favicon}
					defaultImage={Favicon}
					name={'FAVICON'}
					dbName={'customFavicon'}
					setParam={setParam}
					onValidation={handleFaviconValidation}
					folder={folder}
				/>
			</FormControl>

			<FormControl title={I18n('MY_BRAND', 'PRIMARY_COLOR')}>
				{loadingPrimaryColor ? (
					<i className="fas fa-spinner fa-spin" />
				) : (
					<ChromePicker
						color={primaryColor}
						onChangeComplete={(e) => {
							setLoadingPrimaryColor(true);
							setParam({ customPrimaryColor: e.hex })
								.then(() => {
									setPrimaryColor(e.hex);
									setLoadingPrimaryColor(false);
								})
								.catch(() => {
									setLoadingPrimaryColor(false);
								});
						}}
					/>
				)}
			</FormControl>

			<FormControl title={I18n('MY_BRAND', 'FOOTER')}>
				<ChangeText name="footer" dbName="customFooter" setParam={setParam}>
					<input
						className="form-control"
						name="footer"
						defaultValue={customFooter}
					/>
				</ChangeText>
			</FormControl>

			<FormControl title={I18n('MY_BRAND', 'COMPANY_LINK')}>
				<ChangeText name="link" dbName="customLink" setParam={setParam}>
					<div className="input-group mb-3">
						<div className="input-group-prepend">
							<span className="input-group-text">https://</span>
						</div>
						<input
							className="form-control"
							name="link"
							defaultValue={(customLink || '').replace('https://', '')}
						/>
					</div>
				</ChangeText>
			</FormControl>
		</div>
	);
};

export default View;

const FormControl = ({ title = '', children = null }) => {
	return (
		<div className="row row-xs align-items-center mg-b-20">
			<div className="col-md-4">
				<label className="form-label mg-b-0">{title}</label>
			</div>
			<div className="col-md-8 mg-t-5 mg-md-t-0">{children}</div>
		</div>
	);
};
